import { render } from "./OurRecentNews.vue?vue&type=template&id=acc04afc"
import script from "./OurRecentNews.vue?vue&type=script&lang=js"
export * from "./OurRecentNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__